import { MARQUEE_ITEMS } from "@/lib/data";

function Row({ hidden }) {
    return (
        <div className="flex items-center shrink-0" aria-hidden={hidden ? "true" : undefined}>
            {MARQUEE_ITEMS.map((item) => (
                <span key={item} className="flex items-center shrink-0">
                    <span className="font-mono text-[11px] tracking-[0.32em] text-vera-mut px-8 whitespace-nowrap">{item}</span>
                    <span className="w-1.5 h-1.5 rotate-45 border border-vera-gold/70 shrink-0" aria-hidden="true" />
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <div className="relative border-y border-white/10 bg-vera-bg2/40 overflow-hidden py-5" data-testid="editorial-marquee">
            <div className="flex w-max animate-marquee">
                <Row />
                <Row hidden />
            </div>
            <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-vera-bg to-transparent" aria-hidden="true" />
            <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-vera-bg to-transparent" aria-hidden="true" />
        </div>
    );
}
